import {
    faArrowUpRightFromSquare,
    faChevronLeft,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@heroui/react";
import { createFileRoute, Link } from "@tanstack/react-router";
import NewFieldForm from "@/components/field/NewFieldForm";
import useFeatureFlag from "@/lib/featureFlags/useFeatureFlags";

export const Route = createFileRoute("/dashboard/fields/add")({
    component: RouteComponent,
});

function RouteComponent() {
    const { bulkFieldUploadEnabled } = useFeatureFlag();
    return (
        <div className="h-full flex flex-col">
            <div className="flex flex-row gap-1 items-center p-2">
                <Button
                    variant="light"
                    isIconOnly
                    size="lg"
                    as={Link}
                    href="/dashboard/fields"
                    aria-label="Back to Dashboard"
                >
                    <FontAwesomeIcon icon={faChevronLeft} size="lg" />
                </Button>

                <div className="flex flex-row gap-2 items-center justify-between w-full">
                    <div className="font-bold text-3xl">Add Field</div>
                    {bulkFieldUploadEnabled && (
                        <Button
                            as={Link}
                            to="/dashboard/fields/add-bulk"
                            color="primary"
                            size="sm"
                        >
                            <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                            Bulk File Upload
                        </Button>
                    )}
                </div>
            </div>
            <NewFieldForm />
        </div>
    );
}
